import { observable } from 'mobx'

import { EmployeeDTO } from 'sections/LKSection/modules/EmployeeModule/types/typesDTO'
import { Entity } from 'shared/stores/BaseStore'
import { Country } from 'shared/types/types'

export class Employee extends Entity {
  @observable firstName = ''
  @observable lastName = ''
  @observable middleName = ''
  @observable name = ''
  @observable phone = ''
  @observable country = Country.RU
  @observable pvzId = 0
  @observable rating = 0
  @observable isDeleted = false
  @observable snils = ''

  constructor(props: Employee) {
    super(props)
    Object.assign(this, props)
  }

  static create({ userId, ...other }: EmployeeDTO, pvzId: number) {
    return new Employee({ ...other, id: userId, pvzId })
  }
}
